import actions from '@/store/modules/acquisition/actions';
import mutations from '@/store/modules/acquisition/mutations';
import state from '@/store/modules/acquisition/state';

export default {
  actions,
  mutations,
  state
};
